import { imgRoot } from "../constant/app-paths";
import { Item } from "../model/search-base-model";


export const getStaticItems = (): Item[] => {
  return [
    {
      id: '1',
      name: 'Window X',
      productType: [
        {
          value: 'window',
        }
      ],
      imgs: [`${imgRoot}aluminum-70100.jpeg`, `${imgRoot}aluminum-70100-1.jpeg`, `${imgRoot}aluminum-70100-2.jpeg`, `${imgRoot}aluminum-70100-3.jpeg`],
      searchContent: 'Window X, one',
    },
    {
      id: '2',
      name: 'Window Y',
      productType: [
        {
          value: 'window',
        }
      ],
      imgs: [`${imgRoot}aluminum-100.jpeg`, `${imgRoot}aluminum-100-1.jpeg`, `${imgRoot}aluminum-100-2.jpeg`, `${imgRoot}aluminum-100-3.jpeg`],
      searchContent: 'Window X, one',

    },
    {
      id: '3',
      name: 'Window Z',
      productType: [
        {
          value: 'window',
        }
      ],
      imgs: [`${imgRoot}aluminum-70-100.jpeg`, `${imgRoot}aluminum-70-100-1.jpeg`],
      searchContent: 'Window Z two',
    },
    {
      id: '4',
      name: 'Door X',
      productType: [
        {
          value: 'door',
        }
      ],
      imgs: [`${imgRoot}aluminum-door-70-100.jpeg`, `${imgRoot}aluminum-door-70-100-1.jpeg`],
      searchContent: 'Door X Three',
    },
    {
      id: '5',
      name: 'Door Y',
      productType: [
        {
          value: 'door',
        }
      ],
      imgs: [`${imgRoot}aluminum-door-70-100-gold.jpeg`, `${imgRoot}aluminum-door-70-100-gold-1.jpeg`],
      searchContent: 'Door Y Four',
    },
    {
      id: '7',
      name: 'Door Z',
      productType: [
        {
          value: 'door',
        }
      ],
      imgs: [`${imgRoot}door-140.jpeg`, `${imgRoot}door-140-1.jpeg`],
      searchContent: 'Door Z Five',
    },
  ];

};